export const formatDateTime = (iso: string | null): string => {
  if (!iso) return '—';
  try {
    const date = new Date(iso);
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch {
    return iso;
  }
};

export const formatDate = (iso: string | null): string => {
  if (!iso) return '—';
  try {
    const date = new Date(iso);
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  } catch {
    return iso;
  }
};

export const summarizePermissions = (permissions: string[]): string => {
  if (permissions.length === 0) return 'Sem permissões';
  if (permissions.length <= 2) return permissions.join(', ');
  const [first, ...rest] = permissions;
  return `${first} +${rest.length}`;
};
